import React, { useRef, useState } from "react";
// import FormikSelect from "../../../../Components/Formik/FormikSelect";
// import FormikInput from "../../../../Components/Formik/FormikInput";
import { useFormikContext } from "formik";
import { fileToBase64 } from "../../../../utilities/fileToBase64";
import { useLanguage } from "../../../../Components/LangTranslation/LanguageContext";
// import { useSession } from "../../../../authentications/SessionContext";
// import { Tooltip as ReactTooltip } from "react-tooltip";

const Contract = ({ submissionType, setSubmissionType }) => {
  const { setFieldValue, errors, touched, setFieldTouched, setFieldError } =
    useFormikContext();
  const fileInputRefContract = useRef();
  const [fileNameContract, setFileNameContract] = useState("");

  const { language, translations } = useLanguage();
  const t = translations[language];
  //   const { sessionInfo } = useSession();
  //   const { isVTEX } = sessionInfo;
const handleImageUpload = (e, setFile, key) => {
  const file = e.target.files[0];

  if (file) {
    if (file.size > 2 * 1024 * 1024) {
      setFieldError(key, "File size should not exceed 2MB!");
      setFieldTouched(key, true, false);
      return;
    }

    setFile(file.name);
    fileToBase64(file, (_, base64) => {
      setFieldValue(key, base64 || "");

    
      setFieldError(key, "");
      setFieldTouched(key, false); 
    });
  }
};


  const UploadFileButton = ({
    inputRef,
    fileName,
    uploadText,
    setState,
    keyName,
  }) => {
    return (
      <div className="d-grid mb-2">
        <div
          style={{
            border: "1px solid #cbcbcb",
          }}
          role="button"
          onClick={() => inputRef.current.click()}
          className="p-2 px-3  d-flex justify-content-center align-items-center"
        >
          <i className="far fa-file-pdf text-danger me-3 fa-lg"></i>
          {t[uploadText]} {fileName}
        </div>
        <input
          ref={inputRef}
          onChange={(e) => handleImageUpload(e, setState, keyName)}
          type="file"
          name={keyName}
          hidden
          accept=".pdf"
        />
        {touched[keyName] && errors[keyName] && (
          <span className="ps-2 error-message">{errors[keyName]}</span>
        )}
      </div>
    );
  };
  return (
    <>
      {/* {sessionInfo.isVTEX && (
        <div
          className="alert alert-primary d-flex align-items-center"
          // style={{
          //   height: 12 + "px",
          //   padding: "9px !important",
          // }}
          role="alert"
        >
          <i className="bi bi-info-circle mx-2"></i>{" "}
          <span>Upload required documents!</span>
        </div>
        )} */}
      <div
        style={{
          border: "1px solid #cbcbcb",
          borderRadius: "15px",
          borderStyle: "dashed",
        }}
        className="col-12 row me-0 my-3 pe-0"
      >
        <div className="col-12 col-md-6 my-3">
          <h6 className="text-secondary">
            {t["Choose the contract submission type:"]}
          </h6>
          <div className="form-check w-md-25 w-75 d-none">
            <input
              className="form-check-input"
              type="radio"
              name="contractRadios"
              id="online"
              value="online"
              checked={submissionType === "online"}
              onChange={() => setSubmissionType("online")}
            />
            <label className="form-check-label text-secondary" htmlFor="online">
              {t["Online"]}
            </label>
          </div>
          <div className="form-check w-md-25 w-75">
            <input
              className="form-check-input"
              type="radio"
              name="contractRadios"
              id="manual"
              value="manual"
              checked={submissionType === "manual"}
              onChange={() => setSubmissionType("manual")}
            />
            <label className="form-check-label text-secondary" htmlFor="manual">
              {t["Manual"]}
            </label>
          </div>
        </div>

        {submissionType === "manual" && (
          <>
            <div className="col-12 mt-3">
              <h6 className="text-center text-secondary fw-bold">
                {t["Upload required documents in PDF"]}
              </h6>
            </div>
            <div className="d-flex flex-lg-row flex-column my-3 col-12 p-4 justify-content-center align-items-center gap-3">
              <UploadFileButton
                fileName={fileNameContract}
                inputRef={fileInputRefContract}
                keyName="contract"
                setState={setFileNameContract}
                uploadText="Contract"
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Contract;
